<template>
  <div></div>
</template>

<script>
export default {
  name: "AppTotolu",
  mounted() {
    location.href = "https://puri.sega.jp/totolu/app/";
  },
};
</script>

<style lang="scss" scoped></style>
